export default __webpack_public_path__ + "static/media/authLogo.5937b601.svg";